module.exports = __webpack_public_path__ + "fonts/Barlow-Medium.25662b56.woff2";